/* Product-specific custom inquiries; the normal purchase path is unchanged. */
(function () {
  'use strict';
  if (window.__artmereCustomizePaintingBound) return;
  window.__artmereCustomizePaintingBound = true;

  function context(link) {
    var product = link.closest('.shopify-section') || document;
    var variant = product.querySelector('input[name="variant-id"]:checked') ||
      product.querySelector('form[action*="/cart/add"] [name="id"]');
    var size = product.querySelector('select.artmere-size-mobile-select');
    var frame = product.querySelector('input[name*="Frame"]:checked');
    return {
      product_id: link.dataset.productId || '',
      product_handle: link.dataset.productHandle || '',
      product_title: link.dataset.productTitle || '',
      product_url: link.dataset.productUrl || '',
      variant_id: variant && variant.value || new URLSearchParams(location.search).get('variant') || '',
      size: size && size.selectedOptions[0] && size.selectedOptions[0].textContent.trim() || '',
      finish: frame && (frame.getAttribute('aria-label') || frame.value) || '',
      page_location: location.href,
      surface: 'pdp_customize_accordion'
    };
  }

  function measure(name, data) {
    try {
      if (typeof window.artmerePublishMeasurementEvent === 'function') {
        window.artmerePublishMeasurementEvent(name, data);
      }
    } catch (error) { /* Measurement never blocks the inquiry. */ }
  }

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details.matches || !details.matches('.block-artmere_customize_painting details') || !details.open) return;
    var link = details.querySelector('[data-artmere-customize-link]');
    if (link) measure('customize_painting_open', context(link));
  }, true);

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-artmere-customize-link]');
    if (!link) return;
    var data = context(link);
    var url = new URL(link.href, location.href);
    url.searchParams.set('inquiry', 'custom');
    ['product_id', 'product_handle', 'product_title', 'product_url', 'variant_id', 'size', 'finish'].forEach(function (key) {
      if (data[key]) url.searchParams.set(key, data[key]);
    });
    link.href = url.toString();
    measure('customize_painting_click', data);
  });
})();
